import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=4cbc56f4&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=4cbc56f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbc56f4",
  null
  
)

export default component.exports